import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from 'app/core/constants/api-endpoints.constant';
import { ApiService } from 'app/shared/constant/api-service/api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class FinancingCalculatorService {
    constructor(private _apiService: ApiService) {}

    getProducts(): Observable<any> {
        return this._apiService.get(API_ENDPOINTS.PRODUCTS);
    }
}
